<template>
  <div class="product-data">
    <Header/>
    <div class="content">
      <div class="label">
        <span>{{ $t('satellite.CurrentPosition') }}：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ $t('satellite.Home') }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/algorithm' }">{{ $t('header.AlgorithmPlatform') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ algorithmDetail.algoName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="padding-box">
        <p class="name">{{ algorithmDetail.algoName }}</p>
        <div class="date-num-level">
          <div class="date-num-level-box">
            <div class="label-site">
              <div class="logo center">
                <span class="iconfont icon-shijian labels la1"></span>
              </div>
              <div class="label-text">
                <p>{{ algorithmDetail.updatedTime }}</p>
                <p>{{ $t('product.LastUpdateTime') }}</p>
              </div>
            </div>
            <div class="label-site" style="margin:0 102px;">
              <div class="logo center">
                <span class="iconfont icon-sjfwl labels la2"></span>
              </div>
              <div class="label-text">
                <p>{{ byte2Auto(DataNum) }}</p>
                <p>{{ $t('product.Datavolume') }}</p>
              </div>
            </div>
            <div class="label-site">
              <div class="logo center">
                <span class="iconfont icon-zhongjianren labels la3"></span>
              </div>
              <div class="label-text" style="flex:1;">
                <p>{{ algorithmDetail.name }}</p>
                <p>{{ $t('algorithm.AlgorithmContributors') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="info-box">
          <div class="left">
            <div class="layout-box">
              <div class="basic-info" :class="isEnglish?'basic-info-en':''">
                <p class="bl-title" style="margin-top: 0px;">{{ $t('satellite.BasicInformation') }}</p>
                <hr>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('algorithm.AlgorithmStatus') }}：</div>
                  <span class="basic-info-value">{{ algorithmDetail.state }}</span>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('algorithm.OnlineTime') }}：</div>
                  <span class="basic-info-value">{{ algorithmDetail.uploadTime }}</span>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('DataSubmission.ProductCategory') }}：</div>
                  <span class="basic-info-value">{{ algorithmDetail.dataTypeName }}</span>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('algorithm.SharingMetho') }}：</div>
                  <span class="basic-info-value">{{ algorithmDetail.shareTypeName }}</span>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('algorithm.Region') }}：</div>
                  <span class="basic-info-value">{{ algorithmDetail.algoDataSpace }}</span>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('algorithm.TemporalResolution') }}：</div>
                  <span
                      class="basic-info-value">{{
                      algorithmDetail.timeResolution
                    }}/{{ timeUnit(algorithmDetail.timeResolutionUnit) }}</span>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('algorithm.SpatialResolution') }}：</div>
                  <span class="basic-info-value">{{ algorithmDetail.spatialResolution }}</span>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('algorithm.ProgrammingLanguage') }}：</div>
                  <span class="basic-info-value">{{ algorithmDetail.devLangName }}</span>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('algorithm.OperatingPlatform') }}：</div>
                  <span class="basic-info-value">{{ algorithmDetail.runPlatform }}</span>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('algorithm.Modelcomplexity') }}：</div>
                  <span class="basic-info-value">{{ algorithmDetail.modelComplexityName }}</span>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('algorithm.Modeldrivingdata') }}：</div>
                  <span class="basic-info-value">{{ algorithmDetail.modelDriveData }}</span>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('algorithm.ModelOutputFormat') }}：</div>
                  <span class="basic-info-value">{{ algorithmDetail.modelOutputType }}</span>
                </div>
              </div>
              <div class="connect" :class="isEnglish?'connect-en':''">
                <p class="bl-title" style="margin-top: 0px;">{{ $t('algorithm.DataContactInformation') }}</p>
                <hr>
                <div class="connect-site">
                  <div class="connect-title">{{ $t('product.Contact') }}：</div>
                  <span class="connect-value">{{ algorithmDetail.name }}</span>
                </div>
                <div class="connect-site">
                  <div class="connect-title">{{ $t('product.Phone') }}：</div>
                  <span class="connect-value">{{ algorithmDetail.phone }}</span>
                </div>
                <div class="connect-site">
                  <div class="connect-title">{{ $t('product.Mail') }}：</div>
                  <span class="connect-value">{{ algorithmDetail.email }}</span>
                </div>
                <div class="connect-site">
                  <div class="connect-title">{{ $t('product.Institution') }}：</div>
                  <span class="connect-value">{{ algorithmDetail.organizational }}</span>
                </div>
                <div class="connect-site">
                  <div class="connect-title">{{ $t('product.Address') }}：</div>
                  <span class="connect-value">{{ algorithmDetail.address }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="product-image">
              <img
                  style="width: 100%; height: 100%;border: 0px"
                  :src="mediaDown+algorithmDetail.productDescImageResponse.mediaUrl"/>
            </div>
          </div>
        </div>
        <div class="summary">
          <p class="bl-title">{{ $t('algorithm.AlgorithmicProductionStatistics') }}</p>
          <hr>
          <div class="chart-box">
            <div class="chart-site" id="chart1"></div>
            <div class="chart-site" id="chart2"></div>
          </div>
        </div>
        <div class="summary">
          <p class="bl-title">{{ $t('algorithm.DataAcquisitionMethod') }}</p>
          <hr>
          <el-button size="mini" type="primary" @click="goProduct">{{
              $t('algorithm.DownloadExistingData')
            }}
          </el-button>
          <el-button v-if="algorithmDetail.applyFlag==='1'" size="mini" @click="showApplyRun=true">
            {{ $t('algorithm.Applicationforoperation') }}
          </el-button>
          <el-dialog
              :title="algorithmDetail.algoName"
              :modal-append-to-body="false"
              :visible.sync="showApplyRun"
              width="50%"
              center>
            <div class="main-box-apply">
              <div class="row">
                <p style="margin-bottom:12px;">{{ $t('algorithm.DataNeedsTime') }}</p>
                <el-date-picker
                    v-model="applyTime"
                    value-format="yyyy-MM-dd"
                    size="mini"
                    type="date"
                    :placeholder="$t('product.optiondate')">
                </el-date-picker>
              </div>
              <div class="row">
                <p style="margin:12px 0;">{{ $t('algorithm.SpatialRangeRequiredForData') }}</p>
                <div class="spaceRange">
                  <div id="spaceRange">
                  </div>
                  <div class="tool-sc">
                    <div class="dbx tt center" @click="drawPolygons">
                      <span class="iconfont icon-babianxing"></span>
                    </div>
                    <div class="fx tt center" @click="addRectArea">
                      <span class="iconfont icon-juxing"></span>
                    </div>
                  </div>
                </div>
                <p style="text-align: right;margin-top: 10px">{{
                    $t('cloudComputing.Mapsource')
                  }}：{{ $t('cloudComputing.Tianditu') }}</p>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
                        <el-button size="mini" @click="showApplyRun = false">{{
                            $t('DataSubmission.Cancel')
                          }}</el-button>
                        <el-button size="mini" type="primary" @click="submitApply">{{
                            $t('DataSubmission.confirm')
                          }}</el-button>
                    </span>
          </el-dialog>
        </div>
        <div class="annex suanfaimg">
          <p class="bl-title">{{ $t('algorithm.AlgorithmSummary') }}</p>
          <hr>
          <p class="an-content a1" v-html="algorithmDetail.algoSummary"></p>
        </div>
        <div class="use-info suanfaimg">
          <p class="bl-title">{{ $t('algorithm.AlgorithmDescription') }}</p>
          <hr>
          <p class="use-content u1" v-html="algorithmDetail.algoDesc"></p>
        </div>

        <div class="annex">
          <p class="bl-title">{{ $t('algorithm.OutputProduct') }}</p>
          <hr>
          <p class="an-content a1">{{ algorithmDetail.modelOutputName }}</p>
        </div>

        <div class="annex cankaowenxian">
          <p class="bl-title">{{ $t('algorithm.References') }}</p>
          <hr>
          <p class="a1" v-html="algorithmDetail.relevantInformation"></p>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>

import Header from "@/components/Header"
import Footer from "@/components/Footer"
import * as echarts from 'echarts';

import L from 'leaflet';
import {tiandituTileLayer} from '@supermap/iclient-leaflet';

import {
  getAlgorithmDetail,
  conutByAlgoId,
  applyCreateData
} from "@/api/algorithm/index"
import {mapGetters} from "vuex";

export default {
  name: 'product-data',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      showApplyRun: false,
      productId: null,
      DataNum: 0,
      applyTime: '',
      algorithmDetail: {
        algoName: '',
        updatedTime: '',
        name: '',
        organizational: '',
        uploadTime: '',
        topicTypeName: '',
        shareTypeName: '',
        timeResolution: '',
        timeResolutionUnit: '',
        spatialResolution: '',
        compileEnv: '',
        modelComplexityName: '',
        modelDriveData: '',
        modelOutputType: '',
        phone: '',
        applyFlag: '0',
        email: '',
        address: '',
        algoSummary: '',
        algoDesc: '',
        modelOutputName: '',
        relevantInformation: '',
        productDescImageResponse: {
          mediaUrl: ''
        },
      },
      map: null,
      drawGroup: null,
      drawDataMap: [],
      activeDraw: 0,
      geometry: [],
      isEnglish: false
    }
  },
  computed: {
    ...mapGetters(['shopTotal_getter']),
  },
  watch: {
    showApplyRun(val) {
      if (val) {
        this.$nextTick(() => {
          this.initApplyRange()
        })
      }
    },
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
    this.conutByAlgoId_fuc(this.productId)
  },
  methods: {
    async submitApply() {
      if (this.promisShow(2)) {
        return
      }
      if (this.applyTime.length === 0) {
        this.$message.warning(this.isEnglish ? 'Please select a time range' : '请选择时间范围')
        return
      }
      if (this.drawDataMap.length === 0) {
        this.$message.warning(this.isEnglish ? 'Please select a space range' : '请选择空间范围')
        return
      }
      const params = {
        startTime: this.applyTime + ' 00:00:00',
        endTime: this.applyTime + ' 23:59:59',
        pointList: this.drawDataMap,
        algoId: this.productId
      }
      let res = await applyCreateData(params)
      if (res.code == '000000') {
        this.$message.success(this.isEnglish ? 'The algorithm application runs successfully, and the system will automatically generate an order for you after the operation' : '算法申请运行成功，运行完成后系统将为您自动生成订单！')
      }

      this.showApplyRun = false
    },
    addRectArea() {
      this.$message(this.isEnglish ? 'Start box range' : '开始框选范围');
      this.activeDraw = 2
      this.drawDataMap = []
      var that = this;

      that.map.off("click")
      that.map.off("dblclick")
      that.map.off("dblclick")
      this.removePolygon()
      this.drawGroup.clearLayers()
      if (that.stopRectArea != null) {  //stopRectArea在data中定义，清除重复的拉框操作
        that.map.off('mousedown', that.stopRectArea.mousedown);
      }
      var rectangleMeasure = {
        startPoint: null,
        endPoint: null,
        rectangle: null,
        layer: this.drawGroup,
        color: "rgba(51,136,255,1)",
        addRectangle: function () {
          rectangleMeasure.destory();
          var bounds = [];
          bounds.push(rectangleMeasure.startPoint);
          bounds.push(rectangleMeasure.endPoint);
          rectangleMeasure.rectangle = L.rectangle(bounds, {color: rectangleMeasure.color, weight: 1});
          rectangleMeasure.rectangle.addTo(rectangleMeasure.layer);
          rectangleMeasure.layer.addTo(that.map);
        },
        mousedown: function (e) {
          rectangleMeasure.rectangle = null;
          that.map.dragging.disable();
          rectangleMeasure.startPoint = e.latlng;
          that.map.on('mousemove', rectangleMeasure.mousemove)
        },
        mousemove: function (e) {
          rectangleMeasure.endPoint = e.latlng;
          rectangleMeasure.addRectangle();
          that.map.off('mousedown ', rectangleMeasure.mousedown).on('mouseup', rectangleMeasure.mouseup);
        },
        mouseup: function () {
          that.map.dragging.enable();
          that.map.off('mousemove', rectangleMeasure.mousemove).off('mouseup', rectangleMeasure.mouseup);
          that.locations = {}; //locations在data中定义
          that.locations['leftX'] = rectangleMeasure.startPoint.lat;
          that.locations['leftY'] = rectangleMeasure.startPoint.lng;
          that.locations['rightX'] = rectangleMeasure.endPoint.lat;
          that.locations['rightY'] = rectangleMeasure.endPoint.lng;
          that.locations['layer_id'] = rectangleMeasure.layer._leaflet_id;
          that.locations['layer'] = rectangleMeasure.layer;
          that.locations['rectangle'] = rectangleMeasure.rectangle;
          that.drawDataMap.push([rectangleMeasure.startPoint.lat, rectangleMeasure.startPoint.lng])
          that.drawDataMap.push([rectangleMeasure.endPoint.lat, rectangleMeasure.startPoint.lng])
          that.drawDataMap.push([rectangleMeasure.endPoint.lat, rectangleMeasure.endPoint.lng])
          that.drawDataMap.push([rectangleMeasure.startPoint.lat, rectangleMeasure.endPoint.lng])
          // that.drawDataMap.push(())
          //在此处对数据进行处理（1）...
          that.activeDraw = 0
        },
        destory: function () {
          if (rectangleMeasure.rectangle)
            rectangleMeasure.layer.removeLayer(rectangleMeasure.rectangle);
        }
      };
      that.stopRectArea = rectangleMeasure; //记录已点击拉框按钮，未在地图上拉框
      that.map.on('mousedown', rectangleMeasure.mousedown); //在地图上拉框
    },
    removePolygon() {
      for (let ooo of this.geometry) {
        ooo.remove();
      }
    },
    drawPolygons() {
      this.drawDataMap = []
      this.$message(this.isEnglish ? 'Start drawing the polygon range' : '开始绘制多边形范围');
      this.drawGroup.clearLayers()
      var points, lines, tempLines, node;
      let that = this
      that.map.off("mousemove")
      that.map.off("mousedown")
      that.map.off("mouseup")

      function drawPolygon() {
        that.map.doubleClickZoom.disable();
        lines = new L.polyline([]);
        tempLines = new L.polyline([], {dashArray: 5});
        points = [];
        that.geometry = [];
        that.map.on('click', onClick);
        that.map.on('dblclick', onDoubleClick);
        that.map.on('mousemove', onMove)

        function onClick(e) {
          points.push([e.latlng.lat, e.latlng.lng])
          lines.addLatLng(e.latlng)
          that.drawGroup.addLayer(tempLines)
          that.drawGroup.addLayer(lines)
          node = L.circle(e.latlng, {color: '#ff0000', fillColor: 'ff0000', fillOpacity: 1})
          that.drawGroup.addLayer(node)
          that.geometry.push(node)
        }

        function onMove(e) {
          if (points.length > 0) {
            let ls = [points[points.length - 1], [e.latlng.lat, e.latlng.lng], points[0]]
            tempLines.setLatLngs(ls)
            // that.map.addLayer(tempLines)
          }
        }

        function onDoubleClick() {
          that.geometry.push(L.polygon(points).addTo(that.map))
          that.drawDataMap = points
          that.drawDataMap.splice(that.drawDataMap.length - 1, 1)
          points = [];
          node = null;
          that.map.off('click', onClick);    //点击地图
          that.map.off('dblclick', onDoubleClick);
          that.map.off('mousemove', onMove)//双击地图
          that.map.doubleClickZoom.enable();
          //isInPolygon(marker);
        }
      }

      this.removePolygon()
      drawPolygon()
    },
    initApplyRange() {
      if (this.map) {
        this.map.remove()
      }
      this.map = L.map('spaceRange', {
        crs: L.CRS.TianDiTu_WGS84,
        center: [35, 70],
        zoom: 3,
        minZoom: 2,
        maxZoom: 10,
        zoomControl: false
      });
      this.drawGroup = L.layerGroup().addTo(this.map);
      tiandituTileLayer({
        layerType: 'img',
        key: '73ae12883e85f0abe62f8941835a4129'
      })
          .addTo(this.map);
      if (!this.isEnglish) {
        tiandituTileLayer({
          layerType: 'img',
          isLabel: true,
          key: '73ae12883e85f0abe62f8941835a4129',
          noWrap: false,
        })
            .addTo(this.map);
      } else {
        tiandituTileLayer({
          url: 'http://t0.tianditu.gov.cn/eia_c/wmts?&layer=eia&',
          layerType: 'img',
          isLabel: true,
          key: '73ae12883e85f0abe62f8941835a4129'
        })
            .addTo(this.map);
      }
    },
    timeUnit(val) {
      switch (val) {
        case 'y':
          return this.isEnglish ? 'Year' : '年'
        case 'M':
          return  this.isEnglish ? 'Month' : '月'
        case 'd':
          return  this.isEnglish ? 'Day' : '日'
        case 'H':
          return  this.isEnglish ? 'Hour' : '时'
        case 'm':
          return  this.isEnglish ? 'Minute' : '分'
        default:
          return  this.isEnglish ? '' : ''
      }
    },
    goProduct() {
      this.$router.push({
        path: '/product-detail',
        query: {
          ProductId: this.algorithmDetail.productId
        }
      })
    },
    async conutByAlgoId_fuc(val) {
      let res = await conutByAlgoId({id: val})
      console.log(res);
      const v1 = res.data.productNumList
      const v2 = res.data.productDataNumList
      this.DataNum = res.data.productDataSize
      this.initChart(v1, v2)
    },
    async getDetail(val) {
      let that = this
      let res = await getAlgorithmDetail({id: val})
      that.algorithmDetail = res.data
    },
    initChart(val1, val2) {
      var myChart1 = echarts.init(document.getElementById('chart1'));
      var myChart2 = echarts.init(document.getElementById('chart2'));
      console.log(myChart1, myChart2);
      //数量
      const a1_ax = val1.map(item => item.publish_time)
      const a1_data = val1.map(item => item.num)
      let a = {
        title: {
          text: this.isEnglish ? 'Product Quantity Statistics' : '产品数量统计',
          left: '35%'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show: 'true',
          data: ['图例1', '图例2'],
          bottom: '1%'
        },
        grid: {
          left: '12%',
          right: '12%',
          bottom: '15%',
          top: "12%",
        },
        xAxis: {
          type: 'category',
          data: a1_ax,
          axisTick: {
            show: false
          },
          axisLabel: {
            color: 'rgba(126, 139, 160, 1)'
          },
        },
        yAxis: {
          type: 'value',
          name: this.isEnglish ? 'unit:pcs' : '单位:个',
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(121, 169, 218, 0.2)'
            },
          },
        },
        color: ['rgba(54, 117, 255, 1)', 'rgba(93, 162, 255, 1)'],
        series: [
          {
            name: this.isEnglish ? 'Product Quantity' : '产品数量',
            data: a1_data,
            type: 'bar'
          },
        ]
      }
      //数据量
      const a2_ax = val2.map(item => item.f_create_time)
      const a2_data = val2.map(item => this.byte2GB(item.sizes))
      let b = {
        title: {
          text: this.isEnglish ? 'Collect Product Data Volume Statistics' : '产品数据量统计',
          left: '35%'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show: 'true',
          data: ['图例1', '图例2'],
          bottom: '1%'
        },
        grid: {
          left: '12%',
          right: '12%',
          bottom: '15%',
          top: "12%",
        },
        xAxis: {
          type: 'category',
          data: a2_ax,
          axisTick: {
            show: false
          },
          axisLabel: {
            color: 'rgba(126, 139, 160, 1)'
          },
        },
        yAxis: {
          type: 'value',
          name: this.isEnglish ? 'unit:GB' : '单位:GB',
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(121, 169, 218, 0.2)'
            },
          },
        },
        color: ['rgba(54, 117, 255, 1)', 'rgba(93, 162, 255, 1)'],
        series: [
          {
            name: this.isEnglish ? 'Product Data Volume' : '产品数据量',
            data: a2_data,
            type: 'bar'
          },
        ]
      }
      myChart1.setOption(
          a
      )
      myChart2.setOption(
          b
      )
    }
  },
  created() {
    this.productId = this.$route.query.ProductId
    this.getDetail(this.productId)
  }
}
</script>

<style lang="scss">
.cankaowenxian {
  p {
    margin: 10px 0;
    // text-indent: 2em;
  }
}

.suanfaimg {
  img {
    max-width: 100%;
    height: auto;
  }

  .img-middle {
    a {
      img {

      }
    }
  }
}
</style>
<style lang="scss" scoped>
.main-box-apply {

}

#spaceRange {
  width: 100%;
  height: 450px;

}

.spaceRange {
  position: relative;

  .tool-sc {
    position: absolute;
    left: 12px;
    top: 12px;
    background: white;
    border-radius: 3px;
    width: 30px;
    height: 60px;
    z-index: 5000;
  }

  .tt {
    width: 30px;
    height: 30px;
  }
}

.main-map-wh {
  width: 100%;
  height: 100%;
  // background-color: rgba(5,50,89,1);
  // background: rgba(5,50,89,1);
  background-image: url("../../assets/image/product-view-dialog/ditu.png");
}

hr {
  margin: 12px 0;
  @include product_hr_v1_color();
}

.product-data {
  width: 100%;
  @include co_white_to_black();

  .content {
    @include product_bg_v1_color();
    width: 100%;

    .bl-title {
      color: rgba(38, 125, 255, 1);
      font-weight: 600;
      font-size: 18px;
      margin-top: 60px;
    }

    .label {
      display: flex;
      align-items: center;
      height: 60px;
      @include product_bg_v2_color();
      padding-left: 60px;

      /deep/ span {
        font-size: 15px;
        @include co_white_to_black();
      }

      /deep/ a {
        @include co_white_to_black();
      }

      /deep/ .el-breadcrumb__item:last-child {
        span {
          color: rgba(38, 125, 255, 1);
        }
      }

    }

    .padding-box {
      // padding: 0 240px;
      padding: 0 307px;
      padding-bottom: 24px;
    }

    .name {
      text-align: center;
      font-size: 26px;
      padding: 20px 0;
    }

    .date-num-level-box {
      // .la1{
      //     @include product_label_la1_color();
      // }
      // .la2{
      //     @include product_label_la2_color();
      // }
      // .la3{
      //     @include product_label_la3_color();
      // }
      .labels {
        font-size: 24px;
        color: rgb(93, 162, 255);
      }

      height: 120px;
      width: 100%;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      margin-bottom: 12px;

      .label-site {
        display: flex;
        align-items: center;
        width: 326px;
        height: 98px;
        @include product_levelbg_v1_color();
        padding: 0 20px;
        border-radius: 6px;

        .logo {
          width: 71px;
          height: 71px;
          border-radius: 50%;
          margin-right: 10px;
          background: white;
          border: 3px solid rgb(116, 180, 255);
        }

        .label-text {
          font-size: 14px;
          color: white;
        }
      }
    }

    .info-box {
      display: flex;

      .left {
        // width: 1076px;
        width: 973px;
        margin-right: 24px;

        .layout-box {
          display: flex;
          justify-content: space-between;
          font-size: 15px;

          .basic-info {
            width: 48%;

            &-site {
              display: flex;
              align-items: center;
              margin: 3px 0 0 0;
            }

            &-title {
              // width: 100px;
              text-align: right;
              min-width: 100px;
              height: 20px;
              color: rgba(63, 68, 77, 1);
              margin-right: 4px;
            }

            // &-title:after {
            //   display: inline-block;
            //   content: "";
            //   width: 80px;
            // }

            &-value {
              flex: 1;
              color: rgba(112, 119, 128, 1);
            }
          }
          .basic-info-en{
            .basic-info-title{
              min-width: 190px;
              text-align: left;
            }
          }
          .connect {
            width: 48%;

            &-site {
              display: flex;
              align-items: flex-start;
              margin: 3px 0 0 0;
            }

            &-title {
              // width: 66px;
              // text-align: justify;
              height: 20px;
              color: rgba(63, 68, 77, 1);
              margin-right: 4px;
              min-width: 60px;
            }

            // &-title:after {
            //   display: inline-block;
            //   content: "";
            //   width: 66px;
            // }

            &-value {
              flex: 1;
              text-align: justify;
              color: rgba(112, 119, 128, 1);
              word-break: break-all;
            }
          }
          .connect-en{
            .connect-title{
              min-width: 90px;
              word-break: break-all;
            }
          }
        }

        .get-data {
          margin-top: 18px;
        }

        .time-line {
          display: flex;
          justify-content: center;
          margin: 50px 0 80px 0;

          .line-site {
            width: 406px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .circle {
              position: relative;
              width: 20px;
              height: 20px;
              border-radius: 50px;
              background: rgba(25, 144, 255, 1);
              color: white;

              .line {
                width: 363px;
                height: 2px;
                border: 0;
                //    background: rgba(232,232,232,1);
                background: rgba(25, 144, 255, 1);
                position: absolute;
                left: 8px;
                top: 50%;
                transform: translate(0, -50%);
              }
            }

          }
        }

        .date-tools {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .sub-collect {
            cursor: pointer;
            color: rgba(38, 125, 255, 1);
            border: 1px solid rgba(38, 125, 255, 1);
            border-radius: 3px;
            padding: 10px 36px;
            margin-left: 24px;
          }

          .add {
            margin-left: 24px;
            cursor: pointer;
            color: white;
            padding: 10px 36px;
            border-radius: 3px;
            border: 1px solid rgba(38, 125, 255, 0);
            background-color: rgba(38, 125, 255, 1);
          }
        }
      }

      .right {
        width: 302px;
        // height: 480px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .product-image {
          background-color: white;
          height: 200px;
          width: 100%;
        }
      }
    }

    .summary {
      margin: 12px 0 24px 0;

      &-content {
        text-indent: 2em;
      }
    }

    .annex {
      .an-content {
        font-size: 14px;
        margin: 8px 0;

        .down {
          color: rgba(38, 125, 255, 1);
          cursor: pointer;
          margin-left: 120px;
        }
      }

      .a1 {
        font-size: 14px;
        color: rgba(112, 119, 128, 1);
      }
    }

    .use-info {
      margin-top: 24px;

      .use-content {
        text-align: justify;
        margin: 6px 0;
      }

      .u1 {
        font-size: 14px;
        color: rgba(112, 119, 128, 1);
      }
    }

    .important-hint {
      padding-left: 36px;
    }

    .table-data {
      display: flex;
      padding: 0 240px;
      margin-top: 24px;
      padding-bottom: 12px;

      .left {
        flex: 4;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .tables {
          min-height: 60px;

          .tb-center {
            display: flex;
            align-items: center;
          }

          .t1 {
            @extend .tb-center;
            justify-content: center;
            width: 80px;
          }

          .t2 {
            @extend .tb-center;
            width: 200px;

            span {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .t3 {
            @extend .tb-center;
            width: 120px;
          }

          .t4 {
            @extend .tb-center;
            width: 120px;
          }

          .t5 {
            @extend .tb-center;
            width: 180px;
          }

          .t6 {
            @extend .tb-center;
            justify-content: center;
            width: 120px;

          }

          &-header {
            display: flex;
            margin-bottom: 12px;
          }

          &-body {
            max-height: 560px;
            @include product_bo_t2b_color();

            .body-site {
              width: calc(100% - 2px);
              height: 48px;
              @include product_bo_color();
              border-top: 0;
              display: flex;

            }

            .body-site:last-child {
              width: calc(100% - 2px);
              height: 48px;
              @include product_bo_last_color();
              border-top: 0;
              border-bottom: 0;
              display: flex;
            }
          }
        }

        .tools-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 50px;

          .check {
            width: 80px;
          }

          .batch {
            width: 240px;
          }

          ::v-deep .btn-next {
            margin-right: 0;
          }

          ::v-deep .el-pagination {
            padding-right: 0;
          }
        }
      }

      .right {
        flex: 3;
        margin-left: 36px;

        .top {
          .tables-user {
            min-height: 60px;

            .tb-center {
              display: flex;
              align-items: center;

            }

            .t1 {
              @extend .tb-center;
              width: 80px;
            }

            .t2 {
              @extend .tb-center;
              width: 170px;

              span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .t3 {
              @extend .tb-center;
              width: 180px;

              span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .t4 {
              @extend .tb-center;
              flex: 1;
            }

            &-header {
              display: flex;
              margin-bottom: 12px;
            }

            &-body {
              max-height: 300px;
              @include product_bo_t2b_color();

              .body-site {
                width: calc(100% - 2px);
                height: 48px;
                @include product_bo_color();
                border-top: 0;
                display: flex;

              }

              .body-site:last-child {
                width: calc(100% - 2px);
                height: 48px;
                @include product_bo_last_color();
                border-top: 0;
                border-bottom: 0;
                display: flex;
              }
            }
          }
        }

        .bottom {
          .bl-title {
            margin: 12px 0;
          }

          .tables-browse {
            .tb-center {
              display: flex;
              align-items: center;
            }

            .t1 {
              @extend .tb-center;
              flex: 1;
            }

            &-body {
              max-height: 250px;
              @include product_bo_t2b_color();

              .body-site {
                width: calc(100% - 2px);
                height: 48px;
                @include product_bo_color();
                border-top: 0;
                display: flex;
              }

              .body-site:last-child {
                width: calc(100% - 2px);
                height: 48px;
                @include product_bo_last_color();
                border-top: 0;
                border-bottom: 0;
                display: flex;
              }
            }
          }
        }
      }
    }
  }


}

/deep/ .initSwitchs .el-switch__label span {
  color: white;
}

/deep/ .initSwitchs .is-active span {
  color: rgba(38, 125, 255, 1);
}

/deep/ .initSwitchs2 .el-switch__label span {
  color: white;
}

/deep/ .initSwitchs2 .is-active span {
  color: rgba(38, 125, 255, 1);

}

#product2 {
  width: 100%;
  height: 100%;
}

/deep/ .iclient-leaflet-logo {
  display: none;
}

/deep/ .el-pagination > .btn-next {
  margin-right: 0px;
}

.time-r {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 12px;

  .time-site {
    width: 80px;
    height: 20px;
    background-image: url("../../assets/image/product-view-dialog/kuang.png");
    position: relative;

    img {
      width: 8px;
      height: 5px;
    }

    span {
      font-size: 10px;
      color: white;
    }

    .time-picks {
      position: absolute;
      width: 100%;
      height: 20px;
      top: -5px;
      opacity: 0;
    }
  }
}

.chart-box {
  width: 100%;
  display: flex;

  .chart-site {
    width: 50%;
    height: 380px;
  }
}
</style>


